import type { RouteRecordRaw, Router } from 'vue-router'
import { MODULE_PERMISSIONS } from '@/modules/Core/constants/adminAccess'

const OrgChartRoutes: RouteRecordRaw = {
  path: '/org-chart',
  name: 'OrgChartModulePages',
  redirect: { name: 'ManageOrgChartRoute' },
  children: [
    {
      path: '',
      name: 'ManageOrgChartRoute',
      component: () => import('./views/ManageOrgChartView.vue'),
      meta: {
        title: 'چارت سازمانی و مشاغل',
      },
    },
  ],
  meta: {
    layout: 'Default',
    requiredPermissions: [...MODULE_PERMISSIONS.orgChart],
  },
}

export default (router: Router) => {
  router.addRoute(OrgChartRoutes)
}
